import React from 'react'
import { UserManager } from 'oidc-client'
import { Nav, Navbar, NavItem } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { resolve } from '../dependencies'

import NkaButton from 'nka-button'

import './layout.css'
import 'nka-button/dist/style.css'

export default class Login extends React.Component {
    
    _login() {
        resolve(UserManager)
            .signinRedirect()
            .catch(function(err) {
                console.log('feil')
                console.log(err)
            })
    }

    render() {      

        return (
            <div className="container norkart-bakgrunn">
                <Navbar inverse fixedTop collapseOnSelect>
                    <Navbar.Header>
                        <Navbar.Brand style={{ color: 'white', padding: '0 ', marginTop: '5px' }}>
                            <Link
                                to="/"
                                style={{ color: 'white', padding: '0 15px', marginTop: '5px' }}
                            >
                                <span>
                                    <img
                                        src={
                                            process.env.PUBLIC_URL +
                                            '/images/NORKART_SYMBOL_negativ__digital.png'
                                        }
                                        alt="NORKART"
                                        style={{ width: '40px' }}
                                    />
                                </span>
                                <span>NORKART VA</span>
                            </Link>
                        </Navbar.Brand>
                        <Navbar.Toggle />
                    </Navbar.Header>
                    <Navbar.Collapse>
                        <Nav pullRight>
                            <NavItem eventKey={1} href="#">
                                <NkaButton onClick={this._login} buttontype="primary">
                                    LOGG INN
                                </NkaButton>
                                </NavItem>                            
                        </Nav>
                    </Navbar.Collapse>
                </Navbar>

                <div className="listeContainer">
                    <h3 style={{ marginTop: '80px' }}>Velkommen til KOMTEK Vannmålerbytte </h3>

                    <div className="video-responsive">
                        <iframe 
                            title="introfilm"
                            src="https://player.vimeo.com/video/233351622"
                            width="640"
                            height="360"
                            frameBorder="0"
                            allowFullScreen
                            
                        />

                        <p>
                            <a href="https://vimeo.com/233351622">Vannm&aring;lerbytte</a> from{' '}
                            <a href="https://vimeo.com/norkart">Norkart</a> on{' '}
                            <a href="https://vimeo.com">Vimeo</a>.
                        </p>
                    </div>
                    <div style={{ marginTop: '40px' }}>
                       <p>Hva gjør KOMTEK Vannmålerbytte:</p>
                        <ul>
                            <li>Løsning for bytte av vannmålere</li>
                            <li>
                                Rørlegger får et verktøy for å planlegge arbeidslister, varsle via
                                SMS og registrere nødvendig dokumentasjon rundt vannmålerbyttene
                            </li>
                            <li>
                                Kommunen får dokumentasjon og avvik oppdatert direkte i KOMTEK
                                Vannmåler
                            </li>
                        </ul>
                        
                        <p>Vil du lese mer om <a href='https://www.norkart.no/2017/09/13/norkart-lanserer-nytt-verktoy-effektivt-bytte-vannmalere/' target='_blank' rel="noopener noreferrer">KOMTEK Vannmålerbytte</a> </p>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/felles/login.jsx